var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 11.0003H7.345M12 11.0003H12.0117M16.6667 11.0003H16.6783M22.5 11.0003C22.5 16.1547 17.7983 20.3337 12 20.3337C10.2834 20.3395 8.58726 19.9612 7.03583 19.2265L1.5 20.3337L3.1275 15.9937C2.09733 14.5493 1.5 12.8367 1.5 11.0003C1.5 5.84599 6.20167 1.66699 12 1.66699C17.7983 1.66699 22.5 5.84599 22.5 11.0003Z",
    stroke: "#CDCDCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.19d8bdfdb18c855415ba01902d89d38d.svg";
export { ForwardRef as ReactComponent };